import { useMutation } from '@tanstack/react-query'
import { Link } from '@tanstack/react-router'
import { useState } from 'react'
import { AuthShell } from '@/components/auth-shell'
import { BtnPrimary, Field, TextInput } from '@/components/field'
import { apiMutate, ApiError } from '@/lib/api'

export function MotDePasseOubliePage() {
  const [email, setEmail] = useState('')
  const [done, setDone] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const forgot = useMutation({
    mutationFn: () =>
      apiMutate('/staff/auth/password/forgot', 'POST', { email: email.trim().toLowerCase() }),
    onSuccess: () => {
      setError(null)
      setDone(true)
    },
    onError: (e: Error) => setError(e instanceof ApiError ? e.message : e.message),
  })

  return (
    <AuthShell
      title="Mot de passe oublié"
      subtitle="Nous enverrons un lien de réinitialisation si un compte existe pour cet e-mail."
      footer={
        <Link to="/connexion" className="text-rouge underline">
          Retour à la connexion
        </Link>
      }
    >
      {done ? (
        <p className="rounded-lg bg-page px-3 py-3 text-sm text-corps">
          Si un compte correspond à <strong>{email}</strong>, un e-mail a été envoyé depuis{' '}
          <strong>noreply@johnsaks.com</strong>. Vérifiez aussi vos indésirables.
        </p>
      ) : (
        <form
          className="flex flex-col gap-3"
          onSubmit={(e) => {
            e.preventDefault()
            forgot.mutate()
          }}
        >
          {error ? (
            <p className="rounded-lg bg-rouge/10 px-3 py-2 text-sm text-rouge" role="alert">
              {error}
            </p>
          ) : null}
          <Field label="E-mail professionnel">
            <TextInput
              type="email"
              autoComplete="username"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </Field>
          <BtnPrimary type="submit" disabled={forgot.isPending}>
            {forgot.isPending ? 'Envoi…' : 'Envoyer le lien'}
          </BtnPrimary>
        </form>
      )}
    </AuthShell>
  )
}
